import React, { useEffect, useState } from 'react';
import PageShell, { SectionTitle } from './PageShell';
import { useAuth } from '../context/AuthContext';
import { api } from '../lib/api';
import { MessagesChat } from '../components/MessagesChat';
import { Link } from 'react-router-dom';
import { Loader2, UserCheck, MessageCircle } from 'lucide-react';

export default function StudentMessagesPage() {
  const { user, loading: authLoading } = useAuth();
  const [thread, setThread] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (authLoading || !user) return;
    api.messagesThreads()
      .then((d) => setThread(d.threads?.[0] || null))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [authLoading, user]);

  if (authLoading) return <PageShell><div className="max-w-4xl mx-auto p-12 text-white/50">Chargement…</div></PageShell>;
  if (!user) return <PageShell><div className="max-w-3xl mx-auto p-12 text-center text-white/60">Connecte-toi pour accéder à ta messagerie.</div></PageShell>;

  return (
    <PageShell>
      <section className="max-w-4xl mx-auto px-4 lg:px-6 mt-8" data-testid="student-messages-page">
        <SectionTitle kicker="Messagerie" title="Mon enseignant" sub="Pose tes questions directement à ton moniteur — il te répond depuis son espace." />

        {loading ? (
          <div className="flex items-center gap-2 text-white/50 py-16 justify-center"><Loader2 size={16} className="animate-spin" /> Chargement…</div>
        ) : !thread ? (
          <div className="rounded-2xl border border-white/10 bg-white/[0.02] p-12 text-center" data-testid="student-messages-empty">
            <UserCheck size={28} className="mx-auto text-white/25 mb-3" />
            <div className="text-white/70 text-[14.5px] font-semibold">Aucun enseignant rattaché</div>
            <p className="text-white/40 text-[12.5px] mt-2 max-w-md mx-auto">Rattache-toi à ton moniteur avec son code ou son QR pour pouvoir échanger avec lui.</p>
            <Link to="/eleve/dashboard" className="inline-flex items-center gap-2 mt-5 h-10 px-5 rounded-full bg-red-600 hover:bg-red-500 text-white text-[13px] font-semibold">Me rattacher →</Link>
          </div>
        ) : (
          <div className="rounded-2xl border border-white/10 bg-[#0d0d0e] overflow-hidden flex flex-col">
            <div className="px-4 h-12 border-b border-white/10 flex items-center gap-2.5">
              <MessageCircle size={15} className="text-red-400" />
              <span className="text-white text-[14px] font-semibold">{thread.other.name}</span>
              <span className="text-white/35 text-[11.5px]">Enseignant ECSR</span>
            </div>
            <MessagesChat otherId={thread.other.id} otherName={thread.other.name?.split(' ')[0] || 'ton moniteur'} />
          </div>
        )}
      </section>
    </PageShell>
  );
}
